<template>
  <div class="guides-slider-skeleton">
    <div class="slide-skeleton">
      <SkeletonItem class="avatar" />
      <SkeletonItem
        class="line"
        style="width: 120px; height: 18px"
      />
      <div class="meta-group">
        <SkeletonItem
          class="line"
          style="width: 142px"
        />
        <SkeletonItem
          class="line"
          style="width: 142px"
        />
      </div>
      <SkeletonItem
        class="line"
        style="width: 176px"
      />
      <div class="desc-group">
        <SkeletonItem
          class="line"
          style="width: 100%; height: 16px"
        />
        <SkeletonItem
          class="line"
          style="width: 100%; height: 16px"
        />
      </div>
      <SkeletonItem
        class="line"
        style="width: 89%; height: 16px; margin-left: -42px"
      />

      <SkeletonItem class="button" />
    </div>

    <div class="dots">
      <SkeletonItem
        v-for="i in 5"
        :key="i"
        class="dot"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  // Widgets

  // Features

  // Entities

  // Shared

  // External and shared packages
  import { SkeletonItem } from '@experience/core-skeleton-lib';
</script>

<style scoped lang="scss">
  .guides-slider-skeleton {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }

  .slide-skeleton {
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: center;
    width: 100%;
  }

  .avatar {
    width: 120px;
    height: 120px;
    margin-bottom: 4px;
    border-radius: 50%;
  }

  .line {
    height: 14px;
    border-radius: 8px;
  }

  .meta-group,
  .desc-group {
    display: flex;
    gap: 4px;
    align-items: center;
  }

  .meta-group {
    margin-top: 10px;
    margin-bottom: 6px;
  }

  .desc-group {
    flex-direction: column;
    width: 100%;
    margin-top: 9px;
  }

  .button {
    width: 100%;
    height: 48px;
    margin-top: 12px;
    border-radius: 12px;
  }

  .dots {
    display: flex;
    gap: 6px;
    justify-content: center;
  }

  .dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
  }
</style>
